import React from 'react';
import { Link } from 'react-router-dom';
import './Button.css';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  newTab?: boolean;
  href?: string;
  to?: string;
  target?: string;
  variant?: 'primary' | 'secondary' | 'outline' | 'social';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  icon?: IconDefinition;
  isLoading?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  children,
  newTab = true,
  href,
  to,
  target,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  icon,
  isLoading = false,
  ...props
}) => {
  const className = [
    'goat-btn',
    `goat-btn--${variant}`,
    `goat-btn--${size}`,
    fullWidth ? 'goat-btn--full' : '',
  ].filter(Boolean).join(' ');

  const content = (
    <>
      {icon && !isLoading && <span className="goat-btn__icon"><FontAwesomeIcon icon={icon} /></span>}
      {isLoading && <span className="goat-btn__icon goat-btn__spinner"><FontAwesomeIcon icon={faSpinner} spin /></span>}
      <span>{children}</span>
    </>
  );

  // Internal link via react-router
  if (to) {
    return (
      <Link className={className} to={to}>
        {content}
      </Link>
    );
  }

  // External link
  if (href) {
    return (
      <a className={className} href={href} target={newTab ? "_blank" : ""} rel="noopener noreferrer">
        {content}
      </a>
    );
  }

  // Regular button
  return (
    <button className={className} disabled={isLoading} {...props}>
      {content}
    </button>
  );
};

export default Button;
